import React, { useRef } from 'react'
import FormHelperText from '@mui/material/FormHelperText'
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';

const renderFromHelper = ({ touched, error }) => {
    if (!(touched && error)) {
        return
    } else {
        return <FormHelperText style={{ color: '#f44336' }}>{touched && error}</FormHelperText>
    }
}

const FieldFileInput = (props) => {
    // `accept` and `preview` are optional and default to the licence-upload behaviour every existing
    // caller relies on. `preview` swaps the camera icon for a thumbnail of what was picked, for
    // fields where the picture itself is the content (the gift image on a campaign).
    // `viewOnly` hides the remove (×) control so a read-only campaign detail can't clear the image.
    const { input: { onChange, value }, label, meta: { touched, error },
        accept = '.jpg, .png, .jpeg, .pdf', preview = false, viewOnly = false } = props
    const inputFile = useRef(null)
    // A freshly picked file is a base64 data URL; a saved one comes back as its stored https URL.
    const showThumbnail = preview && typeof value === 'string'
        && (value.startsWith('data:image') || value.startsWith('http'))

    function handleFileSelect(e) {
        let document = "";
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = () => {
            document = reader.result;
            onChange(document)
        };
        reader.onerror = function (error) {
        };
    }

    const removeimage = () => {
        onChange('')
    }

    return (
        <div className='text-center'>
            <input
                type='file'
                accept={accept}
                style={{ display: 'none' }}
                onChange={(e) => handleFileSelect(e)} ref={inputFile}
            />
            {preview ?
                // Product-bank style: the file-select control (camera) with its label sits on the left
                // corner and the preview thumbnail shows to its right, both in the same row.
                <div className='d-flex align-items-center justify-content-between' style={{ gap: 16 }}>
                    <div className='text-center'>
                        <img alt={label}
                            src={value !== '' ? require('assets/images/camera_3.png') : require('assets/images/camera_1.png')}
                            className='d-block mx-auto cursor-pointer'
                            onClick={() => inputFile.current.click()} />
                        <label>{label}</label>
                    </div>
                    {showThumbnail &&
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                            <img alt={label} src={value} className='cursor-pointer'
                                style={{ borderStyle: 'solid', borderColor: '#dee2e6', borderWidth: 'thin', borderRadius: 10, padding: 10, width: 150, maxWidth: '100%', maxHeight: 150, objectFit: 'contain' }}
                                onClick={() => inputFile.current.click()} />
                            {/* Clearing the field makes the required validation fail, so Save stays
                                disabled until another image is picked. Hidden in read-only detail view. */}
                            {!viewOnly &&
                                <button type='button' onClick={removeimage}
                                    style={{ position: 'absolute', top: -6, right: -6, backgroundColor: 'transparent', color: 'red', border: 'none', width: 24, height: 24, textAlign: 'center', fontSize: 30, lineHeight: '20px', padding: 0, cursor: 'pointer' }}>
                                    &times;
                                </button>}
                        </div>}
                </div> :
                <div>
                    <img alt="licence" src={value !== '' ? require('assets/images/camera_3.png') : require('assets/images/camera_1.png')} className='d-block mx-auto' onClick={(e) => inputFile.current.click()} />
                    <label>{label}</label>
                </div>}
            {renderFromHelper({ touched, error })}
            {(label === 'GSTN Lic (Optional)' || label === "FSSAI Lic (Optional)") && value && <div className='mr-1 ml-1 d-flex justify-content-center'>
                <Tooltip title={`Remove this document`} onClick={removeimage}>
                    <Avatar className='bg-danger cursor-pointer' size={1}>
                        <i className='zmdi zmdi-close'></i>
                    </Avatar>
                </Tooltip>
            </div>}
        </div>
    )
}

export default FieldFileInput